module.exports = __webpack_public_path__ + "img/0-md.7682ab92.jpg";